'use client';

import { Button } from '@govinity/ui/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@govinity/ui/components/ui/dialog';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useConfirmationStore } from '@/stores/confirmationStore';

function ConfirmationDialogComponent() {
  const t = useTranslations('ConfirmationDialog');
  const {
    title,
    description,
    confirmText,
    cancelText,
    confirmIcon,
    confirmVariant,
    onConfirm,
    onCancel,
    close,
  } = useConfirmationStore();

  const [isDisabled, setIsDisabled] = useState(false);

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onCancel();
    close();
  };

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsDisabled(true);
    onConfirm();
    close();
  };

  const Icon = confirmIcon;

  return (
    <Dialog open onOpenChange={close}>
      <DialogContent className="sm:max-w-[512px]">
        <DialogHeader>
          <DialogTitle>{title ?? t('defaultTitle')}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">
            {description ?? t('defaultDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} disabled={isDisabled}>
            {cancelText ?? t('cancelButton')}
          </Button>
          <Button variant={confirmVariant} onClick={handleConfirm} disabled={isDisabled}>
            {!!Icon && <Icon className="h-4 w-4" />}
            {confirmText ?? t('defaultConfirmText')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function ConfirmationDialog() {
  const isOpen = useConfirmationStore((state) => state.isOpen);

  if (!isOpen) return null;

  return <ConfirmationDialogComponent />;
}
